<div class="container-fluid px-0">
  <div class="row g-0">
    <!-- Side Menu -->
    <div class="col-lg-1 col-12 px-0">
      <app-uiform-side-menu
        [uiformId]="uiformId"
        targetId="edit"
        [usecaseId]="usecaseId"
        [appId]="appId"
      >
      </app-uiform-side-menu>
    </div>

    <!-- Main Content -->
    <div class="col-lg-11 col-12 ps-lg-1 my-margin-left">
      <div class="row mt-2">
        <div class="col-12">
          <!-- Page Title Bar -->
          <div
            class="d-flex justify-content-between flex-wrap gap-2 align-items-center mb-3"
          >
            <h5 class="d-flex align-items-center mb-0">
              <mat-icon color="primary" class="me-2">list</mat-icon>
              <p class="wrap-text mb-0 d-flex align-items-center">
                {{ form.data["title"] }} &rsaquo;
                {{ "Uiformedit.FORM.ENTRY" | translate }}
              </p>
            </h5>
          </div>

          <!-- Main Card -->
          <div class="card">
            <!-- Card Header -->
            <div
              class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2"
            >
              <h6 class="card-title mb-0">{{ form.data["subtitle"] }}</h6>
              <div class="d-flex align-items-center gap-2 flex-wrap">
                <!-- PDF Export -->
                <button
                  *ngIf="
                    entryform.data['id'] > 0 && usecase?.exportEnabled == 1
                  "
                  (click)="exportPDFData()"
                  mat-icon-button
                  color="primary"
                  [attr.aria-label]="'Export to PDF'"
                  matTooltip="{{ 'Remains.Export_to_PDF' | translate }}"
                  matTooltipPosition="above"
                >
                  <mat-icon>picture_as_pdf</mat-icon>
                </button>

                <!-- Share (email) -->
                <button
                  *ngIf="entryform.data['id'] > 0 && usecase?.emailEnabled == 1"
                  (click)="resetShareForm()"
                  mat-icon-button
                  color="primary"
                  [attr.aria-label]="'Share'"
                  matTooltip="{{ 'Remains.Share' | translate }}"
                  matTooltipPosition="above"
                  data-bs-toggle="modal"
                  data-bs-target="#shareModalLabel"
                >
                  <mat-icon>share</mat-icon>
                </button>

                <!-- Info -->
                <button
                  *ngIf="form.data['description']"
                  [routerLink]="['/uiforminfo/' + uiformId]"
                  mat-icon-button
                  class="info-button"
                  [attr.aria-label]="'Form information'"
                  [matTooltip]="form.data['description']"
                  matTooltipPosition="above"
                >
                  <mat-icon color="primary">info</mat-icon>
                </button>
              </div>
            </div>

            <!-- Search / Filter Header -->
            <div class="card-header" *ngIf="getSearchField().length > 0">
              <div class="row g-2 align-items-end">
                <ng-container *ngFor="let e of getSearchField(); let i = index">
                  <!-- REFERENCE KEY -->
                  <div
                    *ngIf="e['refKey'] == 1"
                    class="col-12 col-sm-6 col-md-4 col-xl-3"
                  >
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-select
                        [(ngModel)]="searchform.data[e.code]"
                        (ngModelChange)="onReferenceValueChange(e, $event)"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="
                          ('Uiformedit.SELECT.DEFAULT' | translate) +
                          ' ' +
                          e.label
                        "
                        [ngClass]="{
                          'placeholder-grey':
                            searchform.data[e.code] === undefined ||
                            searchform.data[e.code] === 'undefined' ||
                            searchform.data[e.code] === '' ||
                            searchform.data[e.code] === null,
                        }"
                      >
                        <!-- Search -->
                        <mat-option>
                          <ngx-mat-select-search
                            [placeholderLabel]="'Search ' + e.label + '...'"
                            [noEntriesFoundLabel]="'No results found'"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="e['_searchTerm']"
                          ></ngx-mat-select-search>
                        </mat-option>

                        <!-- None option -->
                        <mat-option [value]="undefined">
                          {{ "Uiformedit.SELECT.DEFAULT" | translate }}
                          {{ e.label }}
                        </mat-option>

                        <!-- Filtered options -->
                        <ng-container
                          *ngFor="
                            let c of form.preload?.[e['primaryUsecase']] || []
                          "
                        >
                          <mat-option
                            *ngIf="
                              !e['_searchTerm'] ||
                              c['_val']
                                ?.toString()
                                .toLowerCase()
                                .includes(e['_searchTerm'].toLowerCase())
                            "
                            [value]="c['id']"
                          >
                            {{ c["_val"] }}
                          </mat-option>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <!-- TEXT / NUMBER etc. (excluding date/time types) -->
                  <div
                    *ngIf="
                      e['refKey'] != 1 &&
                      e['type'] !== 'list' &&
                      e['type'] !== 'file' &&
                      e['type'] !== 'map' &&
                      e['type'] !== 'password' &&
                      e['type'] !== 'doc' &&
                      e['type'] !== 'date' &&
                      e['type'] !== 'idate' &&
                      e['type'] !== 'time' &&
                      e['type'] !== 'itime' &&
                      e['type'] !== 'dateandtime'
                    "
                    class="col-12 col-sm-6 col-md-4 col-xl-3"
                  >
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <input
                        matInput
                        [type]="
                          getInputType(e.type) == 'password'
                            ? 'text'
                            : getInputType(e.type)
                        "
                        [(ngModel)]="searchform.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="getFilterLable(e.label)"
                        (ngModelChange)="onValueChange(e, $event)"
                      />
                    </mat-form-field>
                  </div>

                  <!-- DATE -->
                  <div
                    *ngIf="e['type'] === 'date'"
                    class="col-12 col-sm-6 col-md-4 col-xl-3"
                  >
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{ getFilterLable(e.label) }}</mat-label>
                      <input
                        #searchDateInput
                        matInput
                        type="date"
                        [(ngModel)]="searchform.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        (ngModelChange)="onValueChange(e, $event)"
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="searchDateInput.showPicker()"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >calendar_today</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- IDATE -->
                  <div
                    *ngIf="e['type'] === 'idate'"
                    class="col-12 col-sm-6 col-md-4 col-xl-3"
                  >
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{ getFilterLable(e.label) }}</mat-label>
                      <input
                        #searchIdateInput
                        matInput
                        type="date"
                        [(ngModel)]="searchform.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        (ngModelChange)="onValueChange(e, $event)"
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="searchIdateInput.showPicker()"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >calendar_today</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- TIME -->
                  <div
                    *ngIf="e['type'] === 'time'"
                    class="col-12 col-sm-6 col-md-4 col-xl-3"
                  >
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{ getFilterLable(e.label) }}</mat-label>
                      <input
                        #searchTimeInput
                        matInput
                        type="time"
                        [(ngModel)]="searchform.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        (ngModelChange)="onValueChange(e, $event)"
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="searchTimeInput.showPicker()"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >access_time</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- ITIME -->
                  <div
                    *ngIf="e['type'] === 'itime'"
                    class="col-12 col-sm-6 col-md-4 col-xl-3"
                  >
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{ getFilterLable(e.label) }}</mat-label>
                      <input
                        #searchItimeInput
                        matInput
                        type="time"
                        [(ngModel)]="searchform.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        (ngModelChange)="onValueChange(e, $event)"
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="searchItimeInput.showPicker()"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >access_time</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- DATEANDTIME -->
                  <div
                    *ngIf="e['type'] === 'dateandtime'"
                    class="col-12 col-sm-6 col-md-4 col-xl-3"
                  >
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-label>{{ getFilterLable(e.label) }}</mat-label>
                      <input
                        #searchDateTimeInput
                        matInput
                        type="datetime-local"
                        [(ngModel)]="searchform.data[e.code]"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        (ngModelChange)="onValueChange(e, $event)"
                      />
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        class="icon-pd-none"
                        (click)="searchDateTimeInput.showPicker()"
                      >
                        <mat-icon class="icon-compact text-secondary"
                          >event</mat-icon
                        >
                      </button>
                    </mat-form-field>
                  </div>

                  <!-- LIST -->
                  <div
                    *ngIf="e['type'] === 'list'"
                    class="col-12 col-sm-6 col-md-4 col-xl-3"
                  >
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="w-100"
                    >
                      <mat-select
                        [(ngModel)]="searchform.data[e.code]"
                        (selectionChange)="onChange(e, $event)"
                        id="{{ e.code }}"
                        name="{{ e.code }}"
                        [placeholder]="
                          ('Uiformedit.SELECT.DEFAULT' | translate) +
                          ' ' +
                          e.label
                        "
                        [ngClass]="{
                          'placeholder-grey':
                            searchform.data[e.code] === undefined ||
                            searchform.data[e.code] === 'undefined' ||
                            searchform.data[e.code] === '' ||
                            searchform.data[e.code] === null,
                        }"
                      >
                        <mat-option>
                          <ngx-mat-select-search
                            [placeholderLabel]="'Search...'"
                            [noEntriesFoundLabel]="'No matches'"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="e['_searchTermList']"
                          ></ngx-mat-select-search>
                        </mat-option>

                        <mat-option
                          [disabled]="e['required'] == 1"
                          value="undefined"
                          class="default-option"
                        >
                          {{ "Uiformedit.SELECT.DEFAULT" | translate }}
                          {{ e.label }}
                        </mat-option>

                        <mat-option
                          *ngFor="let c of e['values']"
                          [value]="c"
                          [title]="c"
                          [style.display]="
                            !e['_searchTermList'] ||
                            (c &&
                              c
                                .toString()
                                .toLowerCase()
                                .includes(e['_searchTermList'].toLowerCase()))
                              ? 'flex !important'
                              : 'none !important'
                          "
                        >
                          {{ c }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>

                <!-- GO BUTTON -->
                <div
                  class="col-12 col-sm-6 col-md-4 col-xl-3 d-flex align-items-center"
                >
                  <button
                    (click)="getSearchUiformDataByList()"
                    type="button"
                    mat-stroked-button
                    color="primary"
                  >
                    {{ "Uiformedit.BUTTONS.GO" | translate }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Card Body -->
            <div class="card-body compact-inputs dropdown-pd-none">
              <!-- New Button -->
              <a
                *ngIf="form.data?.buttons?.['new']"
                class="btn btn-outline-secondary btn-sm radius-30 mb-2"
                [title]="'BUTTONS.ADD_NEW' | translate"
                (click)="fieldButtonSubmit('new')"
              >
                <i class="fa fa-plus"></i>
                {{ "Uiformedit.BUTTONS.NEW" | translate }}
              </a>

              <!-- Alerts -->
              <p *ngIf="entryform['error'] == false && entryform['message']">
                <app-ncs-alert
                  [message]="entryform['message']"
                  type="success"
                  showAlert="true"
                />
              </p>
              <p *ngIf="entryform['error'] == true && entryform['message']">
                <app-ncs-alert
                  [message]="entryform['message']"
                  type="danger"
                  showAlert="true"
                />
              </p>

              <!-- Unique Constraint Errors -->
              <ng-container *ngFor="let uni of usecaseSchema.unique">
                <app-ncs-alert
                  *ngIf="isArray(uni) && getInputError(uni.join('_')) !== ''"
                  [message]="getInputError(uni.join('_'))"
                  showAlert="true"
                  type="danger"
                />
              </ng-container>

              <!-- ===== GROUPED FIELDS ===== -->
              <ng-container
                *ngFor="let group of form.data['groupLabels']; let i = index"
              >
                <ng-container *ngIf="checkTime(group)">
                  <ng-container *ngIf="getGroupsField(group.label).length > 0">
                    <fieldset class="border border-secondary rounded p-3 mb-2">
                      <legend
                        class="float-none w-auto px-2 text-secondary fs-6 mb-0 pb-0"
                      >
                        {{ group.label }}
                      </legend>

                      <div *ngIf="form.data['id'] > 0" class="row">
                        <ng-container
                          *ngFor="
                            let field of getGroupsField(group.label);
                            let i = index
                          "
                        >
                          <ng-container *ngIf="getAttributeById(field.id) as e">
                            <!-- TEXTAREA -->
                            <ng-container
                              *ngIf="
                                e['type'] == 'textarea' &&
                                evaluateCondition(field)
                              "
                            >
                              <div
                                class="{{
                                  getColums(form.data.columns, field)
                                }} {{ getRows(field) }} "
                              >
                                <mat-label
                                  class="form-label d-block mb-2"
                                  *ngIf="
                                    e['type'] !== 'file' &&
                                    e['type'] !== 'doc' &&
                                    e['type'] !== 'tags' &&
                                    e['type'] !== 'combobox'
                                  "
                                >
                                  {{ getFilterLable(e.label) }}
                                  <span
                                    *ngIf="e['required'] == 1"
                                    class="text-danger"
                                    >*</span
                                  >
                                  <span *ngIf="e.showDescription !== 1">
                                    <mat-icon
                                      ncsTooltip
                                      [matTooltip]="getDescription(e)"
                                      matTooltipPosition="right"
                                      class="ms-2 text-secondary icon-compact mt-1"
                                      aria-label="Information"
                                      >info</mat-icon
                                    >
                                  </span>
                                  <p
                                    *ngIf="e.showDescription === 1"
                                    class="text-muted mb-0"
                                    style="font-size: 0.875rem"
                                  >
                                    {{ getDescription(e) }}
                                  </p>
                                </mat-label>

                                <div class="form-group col-md-12 mb-2">
                                  <!-- Rich Text Editor -->
                                  <div
                                    class="custom-editor-wrapper"
                                    *ngIf="
                                      e.enableEditor === 1 && editors[e.code]
                                    "
                                  >
                                    <ngx-editor-menu
                                      [editor]="editors[e.code]"
                                      [toolbar]="toolbar"
                                    ></ngx-editor-menu>
                                    <ngx-editor
                                      [(ngModel)]="entryform.data[e.code]"
                                      [editor]="editors[e.code]"
                                      [placeholder]="getFilterLable(e.label)"
                                      class="custom-editor"
                                    ></ngx-editor>
                                  </div>
                                  <!-- Plain Textarea -->
                                  <mat-form-field
                                    *ngIf="e.enableEditor !== 1"
                                    appearance="outline"
                                    class="w-100 textarea-container"
                                    subscriptSizing="dynamic"
                                  >
                                    <textarea
                                      matInput
                                      [ngModel]="
                                        removeHTMLTags(entryform.data[e.code])
                                      "
                                      (ngModelChange)="
                                        entryform.data[e.code] = $event
                                      "
                                      [id]="e.code"
                                      [name]="e.code"
                                      [placeholder]="getFilterLable(e.label)"
                                      cdkTextareaAutosize
                                      cdkAutosizeMinRows="3"
                                      cdkAutosizeMaxRows="10"
                                    ></textarea>
                                  </mat-form-field>
                                </div>
                              </div>
                            </ng-container>

                            <!-- NON-TEXTAREA FIELDS -->
                            <ng-container
                              *ngIf="
                                e['type'] !== 'textarea' &&
                                evaluateCondition(field)
                              "
                            >
                              <div
                                class="{{
                                  getColums(form.data.columns, field)
                                }} {{ getRows(field) }}"
                              >
                                <!-- Label block (shared pattern) -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    fieldLabel;
                                    context: { e: e }
                                  "
                                ></ng-container>

                                <!-- Standard Input -->
                                <div
                                  *ngIf="
                                    e['refKey'] != 1 &&
                                    e['type'] !== 'list' &&
                                    e['type'] !== 'file' &&
                                    e['type'] !== 'map' &&
                                    e['type'] !== 'doc' &&
                                    e['type'] !== 'expression' &&
                                    e['type'] !== 'tags' &&
                                    e['type'] !== 'combobox' &&
                                    e['type'] !== 'location' &&
                                    e['type'] !== 'boolean' &&
                                    e['type'] !== 'password' &&
                                    e['type'] !== 'dateandtime' &&
                                    e['type'] !== 'idate' &&
                                    e['type'] !== 'date' &&
                                    e['type'] !== 'time' &&
                                    e['type'] !== 'itime' &&
                                    e['type'] !== 'json'
                                  "
                                  class="mb-2"
                                >
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                    subscriptSizing="dynamic"
                                  >
                                    <input
                                      matInput
                                      [required]="e['required'] == 1"
                                      [type]="getInputType(e.type)"
                                      [(ngModel)]="entryform.data[e.code]"
                                      [id]="e.code"
                                      [name]="e.code"
                                      [readonly]="
                                        e['readOnly'] ||
                                        (e.allowChangeAfterInitial == 1 &&
                                          entryform.data['id'] > 0)
                                      "
                                      [min]="
                                        e.type === 'date' ? e.minDate : null
                                      "
                                      [max]="
                                        e.type === 'date' ? e.maxDate : null
                                      "
                                      [placeholder]="getFilterLable(e.label)"
                                      (change)="
                                        checkRuleExecute(e.code);
                                        onDateChange(
                                          $event,
                                          e.code,
                                          getInputType(e.type)
                                        );
                                        enforceMaxDate($event, e.code, e.type)
                                      "
                                      (input)="
                                        restrictDecimalPlaces(
                                          $event,
                                          e,
                                          e?.placeValue
                                        )
                                      "
                                      (blur)="checkRuleExecute(e.code)"
                                    />
                                    <mat-icon
                                      *ngIf="e.type === 'date'"
                                      matSuffix
                                      class="date-icon"
                                      >calendar_today</mat-icon
                                    >
                                  </mat-form-field>
                                </div>

                                <!-- DATE -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    dateField;
                                    context: {
                                      e: e,
                                      field: field,
                                      type: 'date',
                                      icon: 'calendar_today',
                                    }
                                  "
                                ></ng-container>
                                <!-- TIME -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    timeField;
                                    context: {
                                      e: e,
                                      field: field,
                                      type: 'time',
                                      icon: 'access_time',
                                    }
                                  "
                                ></ng-container>
                                <!-- ITIME -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    timeField;
                                    context: {
                                      e: e,
                                      field: field,
                                      type: 'itime',
                                      icon: 'access_time',
                                    }
                                  "
                                ></ng-container>
                                <!-- IDATE -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    idateField;
                                    context: { e: e, field: field }
                                  "
                                ></ng-container>
                                <!-- DATETIME -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    datetimeField;
                                    context: { e: e, field: field }
                                  "
                                ></ng-container>

                                <!-- LOCATION -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    locationField;
                                    context: { e: e }
                                  "
                                ></ng-container>

                                <!-- EXPRESSION -->
                                <div
                                  *ngIf="e['type'] === 'expression'"
                                  class="mb-2"
                                >
                                  <mat-form-field
                                    appearance="outline"
                                    class="w-100"
                                    subscriptSizing="dynamic"
                                  >
                                    <input
                                      matInput
                                      [id]="e.code"
                                      [name]="e.code"
                                      [(ngModel)]="entryform.data[e.code]"
                                      [placeholder]="getFilterLable(e.label)"
                                      [required]="e['required'] == 1"
                                      [disabled]="true"
                                      [readonly]="
                                        e['readOnly'] ||
                                        (e.allowChangeAfterInitial == 1 &&
                                          entryform.data['id'] > 0)
                                      "
                                    />
                                  </mat-form-field>
                                </div>

                                <!-- BOOLEAN -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    booleanField;
                                    context: { e: e }
                                  "
                                ></ng-container>

                                <!-- PASSWORD -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    passwordField;
                                    context: { e: e }
                                  "
                                ></ng-container>

                                <!-- JSON -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    jsonField;
                                    context: { e: e, field: field }
                                  "
                                ></ng-container>

                                <!-- REFERENCE KEY -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    refKeyField;
                                    context: { e: e, field: field }
                                  "
                                ></ng-container>

                                <!-- LIST -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    listField;
                                    context: { e: e, field: field }
                                  "
                                ></ng-container>

                                <!-- FILE -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    fileField;
                                    context: { e: e }
                                  "
                                ></ng-container>

                                <!-- DOC -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    docField;
                                    context: { e: e }
                                  "
                                ></ng-container>

                                <!-- MAP -->
                                <ng-container
                                  *ngTemplateOutlet="
                                    mapField;
                                    context: { e: e }
                                  "
                                ></ng-container>

                                <!-- COMBOBOX -->
                                <app-combobox
                                  *ngIf="e['type'] === 'combobox'"
                                  [e]="e"
                                  [entryData]="entryform.data[e.code]"
                                  (valueChange)="
                                    entryform.data[e.code] = $event
                                  "
                                  [readonly]="
                                    e['readOnly'] ||
                                    (e.allowChangeAfterInitial == 1 &&
                                      entryform.data['id'] > 0)
                                  "
                                  [checkExpression]="checkExpression"
                                  [id]="entryform.data['id']"
                                ></app-combobox>

                                <div class="form-text text-danger mb-2">
                                  {{ getInputError(e.code) }}
                                </div>
                              </div>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </div>
                    </fieldset>
                  </ng-container>
                </ng-container>
              </ng-container>

              <!-- ===== UNGROUPED FIELDS ===== -->
              <div *ngIf="form.data['id'] > 0" class="row">
                <ng-container
                  *ngFor="let field of getFieldNotIngroup(); let i = index"
                >
                  <ng-container *ngIf="getAttributeById(field.id) as e">
                    <!-- TEXTAREA (ungrouped) -->
                    <ng-container
                      *ngIf="
                        e['type'] == 'textarea' && evaluateCondition(field)
                      "
                    >
                      <div
                        class="{{ getColums(form.data.columns, field) }} {{
                          getRows(field)
                        }}"
                      >
                        <label
                          for="title"
                          class="form-label"
                          *ngIf="
                            e['type'] !== 'file' &&
                            e['type'] !== 'doc' &&
                            e['type'] !== 'tags' &&
                            e['type'] !== 'combobox'
                          "
                        >
                          {{ getFilterLable(e.label) }}
                          <span *ngIf="e['required'] == 1">*</span>
                          <span *ngIf="e.showDescription !== 1">
                            <mat-icon
                              ncsTooltip
                              [matTooltip]="getDescription(e)"
                              matTooltipPosition="right"
                              class="ms-2 text-secondary icon-compact mt-1"
                              aria-label="Information"
                              >info</mat-icon
                            >
                          </span>
                          <p
                            *ngIf="e.showDescription === 1"
                            class="text-muted mb-0"
                            style="font-size: 0.875rem"
                          >
                            {{ getDescription(e) }}
                          </p>
                        </label>

                        <div class="form-group col-md-12 mb-2">
                          <div
                            class="custom-editor-wrapper"
                            *ngIf="e.enableEditor === 1 && editors[e.code]"
                          >
                            <ngx-editor-menu
                              [editor]="editors[e.code]"
                              [toolbar]="toolbar"
                            ></ngx-editor-menu>
                            <ngx-editor
                              [(ngModel)]="entryform.data[e.code]"
                              [editor]="editors[e.code]"
                              [placeholder]="getFilterLable(e.label)"
                              class="custom-editor"
                            ></ngx-editor>
                          </div>
                          <mat-form-field
                            *ngIf="e.enableEditor !== 1"
                            appearance="outline"
                            class="w-100 textarea-container"
                            subscriptSizing="dynamic"
                          >
                            <textarea
                              matInput
                              [ngModel]="removeHTMLTags(entryform.data[e.code])"
                              (ngModelChange)="entryform.data[e.code] = $event"
                              [id]="e.code"
                              [name]="e.code"
                              [placeholder]="getFilterLable(e.label)"
                              cdkTextareaAutosize
                              cdkAutosizeMinRows="3"
                              cdkAutosizeMaxRows="10"
                            ></textarea>
                          </mat-form-field>
                        </div>
                      </div>
                    </ng-container>

                    <!-- NON-TEXTAREA (ungrouped) -->
                    <ng-container
                      *ngIf="
                        e['type'] !== 'textarea' && evaluateCondition(field)
                      "
                    >
                      <div
                        class="{{ getColums(form.data.columns, field) }} {{
                          getRows(field)
                        }}"
                      >
                        <ng-container
                          *ngTemplateOutlet="fieldLabel; context: { e: e }"
                        ></ng-container>

                        <!-- Standard Input -->
                        <div
                          *ngIf="
                            e['refKey'] != 1 &&
                            e['type'] !== 'list' &&
                            e['type'] !== 'file' &&
                            e['type'] !== 'map' &&
                            e['type'] !== 'doc' &&
                            e['type'] !== 'expression' &&
                            e['type'] !== 'tags' &&
                            e['type'] !== 'combobox' &&
                            e['type'] !== 'location' &&
                            e['type'] !== 'boolean' &&
                            e['type'] !== 'password' &&
                            e['type'] !== 'date' &&
                            e['type'] !== 'dateandtime' &&
                            e['type'] !== 'idate' &&
                            e['type'] !== 'itime' &&
                            e['type'] !== 'time' &&
                            e['type'] !== 'json'
                          "
                          class="mb-2"
                        >
                          <mat-form-field
                            appearance="outline"
                            class="w-100"
                            subscriptSizing="dynamic"
                          >
                            <input
                              matInput
                              [required]="e['required'] == 1"
                              [type]="getInputType(e.type)"
                              [(ngModel)]="entryform.data[e.code]"
                              [id]="e.code"
                              [name]="e.code"
                              [readonly]="
                                e['readOnly'] ||
                                (e.allowChangeAfterInitial == 1 &&
                                  entryform.data['id'] > 0)
                              "
                              [min]="e.type === 'date' ? e.minDate : null"
                              [max]="e.type === 'date' ? e.maxDate : null"
                              [placeholder]="getFilterLable(e.label)"
                              (change)="
                                checkRuleExecute(e.code);
                                onDateChange(
                                  $event,
                                  e.code,
                                  getInputType(e.type)
                                );
                                enforceMaxDate($event, e.code, e.type)
                              "
                              (input)="
                                restrictDecimalPlaces($event, e, e?.placeValue)
                              "
                              (blur)="checkRuleExecute(e.code)"
                            />
                          </mat-form-field>
                        </div>

                        <!-- DATE -->
                        <ng-container
                          *ngTemplateOutlet="
                            dateField;
                            context: {
                              e: e,
                              field: field,
                              type: 'date',
                              icon: 'calendar_today',
                            }
                          "
                        ></ng-container>
                        <!-- TIME -->
                        <ng-container
                          *ngTemplateOutlet="
                            timeField;
                            context: {
                              e: e,
                              field: field,
                              type: 'time',
                              icon: 'access_time',
                            }
                          "
                        ></ng-container>
                        <!-- ITIME -->
                        <ng-container
                          *ngTemplateOutlet="
                            timeField;
                            context: {
                              e: e,
                              field: field,
                              type: 'itime',
                              icon: 'access_time',
                            }
                          "
                        ></ng-container>
                        <!-- IDATE -->
                        <ng-container
                          *ngTemplateOutlet="
                            idateField;
                            context: { e: e, field: field }
                          "
                        ></ng-container>
                        <!-- DATETIME -->
                        <ng-container
                          *ngTemplateOutlet="
                            datetimeField;
                            context: { e: e, field: field }
                          "
                        ></ng-container>
                        <!-- LOCATION -->
                        <ng-container
                          *ngTemplateOutlet="locationField; context: { e: e }"
                        ></ng-container>

                        <!-- EXPRESSION -->
                        <div *ngIf="e['type'] === 'expression'" class="mb-2">
                          <mat-form-field
                            appearance="outline"
                            class="w-100"
                            subscriptSizing="dynamic"
                          >
                            <mat-label>{{ getFilterLable(e.label) }}</mat-label>
                            <input
                              matInput
                              [required]="e['required'] == 1"
                              disabled
                              [(ngModel)]="entryform.data[e.code]"
                              id="{{ e.code }}"
                              name="{{ e.code }}"
                              [readonly]="
                                e['readOnly'] ||
                                (e.allowChangeAfterInitial == 1 &&
                                  entryform.data['id'] > 0)
                              "
                            />
                          </mat-form-field>
                        </div>

                        <!-- BOOLEAN -->
                        <ng-container
                          *ngTemplateOutlet="booleanField; context: { e: e }"
                        ></ng-container>

                        <!-- JSON -->
                        <ng-container
                          *ngTemplateOutlet="
                            jsonField;
                            context: { e: e, field: field }
                          "
                        ></ng-container>

                        <!-- PASSWORD -->
                        <ng-container
                          *ngTemplateOutlet="passwordField; context: { e: e }"
                        ></ng-container>

                        <!-- REFERENCE KEY -->
                        <ng-container
                          *ngTemplateOutlet="
                            refKeyField;
                            context: { e: e, field: field }
                          "
                        ></ng-container>

                        <!-- LIST -->
                        <ng-container
                          *ngTemplateOutlet="
                            listField;
                            context: { e: e, field: field }
                          "
                        ></ng-container>

                        <!-- FILE -->
                        <ng-container
                          *ngTemplateOutlet="fileField; context: { e: e }"
                        ></ng-container>

                        <!-- DOC -->
                        <ng-container
                          *ngTemplateOutlet="docField; context: { e: e }"
                        ></ng-container>

                        <!-- MAP -->
                        <ng-container
                          *ngTemplateOutlet="mapField; context: { e: e }"
                        ></ng-container>

                        <!-- COMBOBOX -->
                        <app-combobox
                          *ngIf="e['type'] === 'combobox'"
                          [e]="e"
                          [entryData]="entryform.data[e.code]"
                          (valueChange)="entryform.data[e.code] = $event"
                          [readonly]="
                            e['readOnly'] ||
                            (e.allowChangeAfterInitial == 1 &&
                              entryform.data['id'] > 0)
                          "
                          [checkExpression]="checkExpression"
                          [id]="entryform.data['id']"
                        ></app-combobox>

                        <div class="form-text text-danger mb-2">
                          {{ getInputError(e.code) }}
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>

                <!-- Placeholder columns -->
                <div
                  *ngFor="let field of form.data['fields']; let i = index"
                  class="{{ getColums(form.data.columns, field) }} {{
                    getRows(field)
                  }}"
                ></div>
              </div>

              <div *ngIf="form.data['id'] == 0">
                {{ "Uiformedit.FORM.NO_FIELDS" | translate }}
              </div>

              <!-- Action Buttons -->
              <div class="text-start mt-2" *ngIf="form.data['id'] > 0">
                <div class="button-group" *ngIf="form.data.readOnly != true">
                  <button
                    *ngFor="let btn of filterBtnAccess()"
                    mat-stroked-button
                    color="primary"
                    class="me-2 mb-1"
                    (click)="fieldButtonSubmit(btn)"
                  >
                    <i [class]="getButtonIcon(btn)"></i>
                    <span class="ms-2">{{
                      getButtonLabel(btn["name"]) | translate
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
            <!-- /card-body -->
          </div>
          <!-- /card -->
        </div>

        <!-- ===== CHILD FORMS ===== -->
        <div *ngIf="entryform['data']['id'] > 0">
          <div
            class="col-12"
            *ngFor="let e of form.data['childFormList']; trackBy: trackByFn"
          >
            <app-child-form-data-list
              *ngIf="componentFlag"
              [flag]="true"
              [uiChildformId]="e['id']"
              [parentChildUsecase]="usecase"
              [foreignId]="id"
            ></app-child-form-data-list>
          </div>
        </div>

        <!-- ===== COMMENTS SECTION ===== -->
        <div
          class="col-12"
          *ngIf="usecase?.commentEnabled == 1 && entryform['data']['id'] > 0"
        >
          <div class="card shadow-sm border-0 mt-2">
            <div
              class="card-header d-flex align-items-center justify-content-between"
            >
              <h6 class="mb-0">
                {{ "UIFORM.COMMENTS.COMMENT" | translate }}
              </h6>
              <button
                mat-stroked-button
                color="primary"
                data-bs-target="#commentModel"
                data-bs-toggle="modal"
                matTooltip="{{ 'UIFORM.COMMENTS.COMMENT' | translate }}"
                aria-label="Add comment"
              >
                <mat-icon>add</mat-icon>
                <span>{{ "UIFORM.COMMENTS.COMMENT" | translate }}</span>
              </button>
            </div>

            <div class="card-body">
              <p
                *ngIf="form['searchError'] == false && form['searchMessage']"
                class="m-0"
              >
                <app-ncs-alert
                  [message]="form['searchMessage']"
                  type="success"
                ></app-ncs-alert>
              </p>
              <p
                *ngIf="form['searchError'] == true && form['searchMessage']"
                class="m-0"
              >
                <app-ncs-alert
                  [message]="form['searchMessage']"
                  type="danger"
                ></app-ncs-alert>
              </p>

              <div class="table-container">
                <div class="table-responsive">
                  <div style="max-height: 400px; overflow-y: auto">
                    <table class="table table-bordered table-hover">
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 5%">#</th>
                          <th style="width: 60%">
                            {{ "UIFORM.COMMENTS.COMMENT" | translate }}
                          </th>
                          <th style="width: 15%">
                            {{ "UIFORM.COMMENTS.USERANDDATE" | translate }}
                          </th>
                          <th class="text-center" style="width: 20%">
                            {{ "UIFORM.COMMENTS.ACTION" | translate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let e of commentList; let i = index"
                          class="align-middle border-bottom"
                        >
                          <td
                            class="py-2 px-2 text-center"
                            style="font-size: 0.85rem"
                          >
                            {{ pageIndex(i) }}
                          </td>
                          <td
                            class="py-2 px-3 text-start"
                            style="font-size: 0.85rem"
                          >
                            {{ e.comment }}
                          </td>
                          <td class="py-2 px-3" style="font-size: 0.85rem">
                            <div
                              class="d-flex align-items-center gap-2 justify-content-end"
                            >
                              <div
                                class="user-avatar"
                                title="{{ e.userFirstname }}"
                              >
                                <span>{{ getInitials(e.userFirstname) }}</span>
                              </div>
                              <span>{{
                                e.createdDatetime | date: "MMM d, y"
                              }}</span>
                            </div>
                          </td>
                          <td class="py-2 px-3" style="font-size: 0.85rem">
                            <div class="d-flex gap-2">
                              <button
                                mat-stroked-button
                                color="primary"
                                class="icon-center icon-width"
                                data-bs-toggle="modal"
                                data-bs-target="#appCommentInfo"
                                (click)="appCommentInfo = e"
                                matTooltip="{{
                                  'COMMON.INFORMATION' | translate
                                }}"
                              >
                                <mat-icon class="icon-compact">info</mat-icon>
                              </button>
                              <button
                                mat-stroked-button
                                color="primary"
                                class="icon-center icon-width"
                                data-bs-toggle="modal"
                                data-bs-target="#commentModel"
                                (click)="getComment(e.id)"
                                matTooltip="{{ 'COMMON.EDIT' | translate }}"
                              >
                                <mat-icon>edit</mat-icon>
                              </button>
                              <button
                                mat-stroked-button
                                color="warn"
                                class="icon-center icon-width"
                                (click)="deleteComment(e.id)"
                                matTooltip="{{ 'COMMON.DELETE' | translate }}"
                              >
                                <mat-icon class="icon-compact">delete</mat-icon>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===== ATTACHMENTS SECTION ===== -->
        <div
          class="col-12"
          *ngIf="usecase?.attachmentEnabled == 1 && entryform['data']['id'] > 0"
        >
          <div class="card mt-2">
            <div
              class="card-header d-flex align-items-center justify-content-between"
            >
              <h6 class="mb-0">
                {{ "UIFORM.ATTACHMENTS.ATTACHMENT" | translate }}
              </h6>
              <button
                mat-stroked-button
                color="primary"
                data-bs-toggle="modal"
                data-bs-target="#attachmentModel"
                matTooltip="{{ 'UIFORM.ATTACHMENTS.ATTACHMENT' | translate }}"
              >
                <mat-icon class="plus-icon">add</mat-icon>
                <span>{{ "UIFORM.ATTACHMENTS.ATTACHMENT" | translate }}</span>
              </button>
            </div>

            <div class="card-body">
              <p *ngIf="form['searchError'] == false && form['searchMessage']">
                <app-ncs-alert
                  [message]="form['searchMessage']"
                  type="success"
                ></app-ncs-alert>
              </p>
              <p *ngIf="form['searchError'] == true && form['searchMessage']">
                <app-ncs-alert
                  [message]="form['searchMessage']"
                  type="danger"
                ></app-ncs-alert>
              </p>

              <div class="table-container">
                <div class="table-responsive">
                  <div style="max-height: 400px; overflow-y: auto">
                    <table
                      class="table table-bordered table-hover align-middle"
                    >
                      <thead class="bg-light">
                        <tr>
                          <th style="width: 5%" class="text-center">#</th>
                          <th style="width: 15%">
                            {{ "UIFORM.ATTACHMENTS.PREVIEW" | translate }}
                          </th>
                          <th style="width: 40%">
                            {{ "UIFORM.ATTACHMENTS.DESCRIPTION" | translate }}
                          </th>
                          <th style="width: 20%">
                            {{ "UIFORM.ATTACHMENTS.USERANDDATE" | translate }}
                          </th>
                          <th style="width: 20%" class="text-center">
                            {{ "UIFORM.ATTACHMENTS.ACTION" | translate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let e of attachmentList; let i = index"
                          class="border-bottom"
                        >
                          <td
                            class="py-3 px-3 text-center"
                            style="font-size: 0.85rem"
                          >
                            {{ pageIndex(i) }}
                          </td>
                          <td class="text-center" style="font-size: 0.85rem">
                            <a
                              href="{{ getAppDoc(e.attachment) }}"
                              target="_blank"
                            >
                              <div class="image-preview">
                                <img
                                  src="{{ getAppDocThumbnail(e.attachment) }}"
                                  class="img-fluid rounded shadow-sm"
                                />
                              </div>
                            </a>
                          </td>
                          <td
                            class="py-2 px-3 text-start"
                            [title]="e.description"
                            style="
                              font-size: 0.85rem;
                              white-space: normal;
                              word-wrap: break-word;
                              overflow-wrap: break-word;
                              cursor: pointer;
                            "
                          >
                            {{ e.description | truncate: 80 }}
                          </td>
                          <td class="py-2 px-3" style="font-size: 0.85rem">
                            <div class="d-flex align-items-center gap-2">
                              <div
                                class="user-avatar shadow-sm"
                                title="{{ e.userFirstname }}"
                              >
                                <span>{{ getInitials(e.userFirstname) }}</span>
                              </div>
                              <span>{{
                                e.createdDatetime | date: "MMM d, y"
                              }}</span>
                            </div>
                          </td>
                          <td class="py-2 px-3" style="font-size: 0.85rem">
                            <div class="d-flex gap-2 justify-content-center">
                              <button
                                mat-stroked-button
                                color="primary"
                                class="icon-center icon-width"
                                data-bs-toggle="modal"
                                data-bs-target="#appAttachmentInfo"
                                (click)="appAttachmentInfo = e"
                                matTooltip="{{
                                  'COMMON.INFORMATION' | translate
                                }}"
                              >
                                <mat-icon class="icon-compact">info</mat-icon>
                              </button>
                              <button
                                mat-stroked-button
                                color="primary"
                                class="icon-center icon-width"
                                data-bs-toggle="modal"
                                data-bs-target="#attachmentModel"
                                (click)="getattachment(e.id)"
                                matTooltip="{{ 'COMMON.EDIT' | translate }}"
                              >
                                <mat-icon>edit</mat-icon>
                              </button>
                              <button
                                mat-stroked-button
                                color="warn"
                                class="icon-center icon-width"
                                (click)="deleteattachment(e.id)"
                                matTooltip="{{ 'COMMON.DELETE' | translate }}"
                              >
                                <mat-icon class="icon-compact">delete</mat-icon>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ================================================================ -->
<!-- REUSABLE FIELD TEMPLATES                                          -->
<!-- ================================================================ -->

<!-- Field Label Template -->
<ng-template #fieldLabel let-e="e">
  <label
    for="title"
    class="form-label"
    *ngIf="
      e['type'] !== 'file' &&
      e['type'] !== 'doc' &&
      e['type'] !== 'expression' &&
      e['type'] !== 'tags' &&
      e['type'] !== 'location' &&
      e['type'] !== 'boolean'
    "
  >
    {{ getFilterLable(e.label) }}
    <span *ngIf="e['required'] == 1" class="text-danger ms-1">*</span>
    <span *ngIf="e.showDescription !== 1">
      <mat-icon
        ncsTooltip
        [matTooltip]="getDescription(e)"
        matTooltipPosition="right"
        class="text-secondary icon-compact ms-2 mt-1"
        aria-label="Information"
        >info</mat-icon
      >
    </span>
    <p
      *ngIf="e.showDescription === 1"
      class="text-muted mb-0"
      style="font-size: 0.875rem"
    >
      {{ getDescription(e) }}
    </p>
  </label>

  <label for="title" class="form-label" *ngIf="e['type'] === 'expression'">
    {{ getFilterLable(e.label) }}
    <span *ngIf="e['required'] == 1" class="text-danger ms-1">*</span>
    <span *ngIf="e.showDescription !== 1">
      <mat-icon
        ncsTooltip
        [matTooltip]="getDescription(e)"
        matTooltipPosition="right"
        class="ms-2 text-secondary icon-compact mt-1"
        >info</mat-icon
      >
    </span>
    <p
      *ngIf="e.showDescription === 1"
      class="text-muted mb-0"
      style="font-size: 0.875rem"
    >
      {{ getDescription(e) }}
    </p>
  </label>

  <label for="title" class="form-label" *ngIf="e['type'] === 'file'">
    {{ getFilterLable(e.label) }}
    <span *ngIf="e['required'] == 1" class="text-danger ms-1">*</span>
    <span *ngIf="e.showDescription !== 1">
      <mat-icon
        ncsTooltip
        [matTooltip]="getDescription(e)"
        matTooltipPosition="right"
        class="ms-2 text-secondary icon-compact mt-1"
        >info</mat-icon
      >
    </span>
    <p
      *ngIf="e.showDescription === 1"
      class="text-muted mb-0"
      style="font-size: 0.875rem"
    >
      {{ getDescription(e) }}
    </p>
  </label>

  <label for="title" class="form-label" *ngIf="e['type'] === 'doc'">
    {{ getFilterLable(e.label) }}
    <span *ngIf="e['required'] == 1" class="text-danger ms-1">*</span>
    <span *ngIf="e.showDescription !== 1">
      <mat-icon
        ncsTooltip
        [matTooltip]="getDescription(e)"
        matTooltipPosition="right"
        class="ms-2 text-secondary icon-compact mt-1"
        >info</mat-icon
      >
    </span>
    <p
      *ngIf="e.showDescription === 1"
      class="text-muted mb-0"
      style="font-size: 0.875rem"
    >
      {{ getDescription(e) }}
    </p>
  </label>

  <label class="form-label" *ngIf="e['type'] === 'location'">
    {{ getFilterLable(e.label) }}
    <span *ngIf="e['required'] == 1" class="text-danger ms-1">*</span>
    <span *ngIf="e.showDescription !== 1">
      <mat-icon
        ncsTooltip
        [matTooltip]="getDescription(e)"
        matTooltipPosition="right"
        class="ms-2 text-secondary icon-compact mt-1"
        >info</mat-icon
      >
    </span>
    <p
      *ngIf="e.showDescription === 1"
      class="text-muted mb-0"
      style="font-size: 0.875rem"
    >
      {{ getDescription(e) }}
    </p>
  </label>

  <label for="title" class="form-label" *ngIf="e['type'] === 'boolean'">
    {{ getFilterLable(e.label) }}
    <span *ngIf="e['required'] == 1" class="text-danger ms-1">*</span>
    <span *ngIf="e.showDescription !== 1">
      <mat-icon
        ncsTooltip
        [matTooltip]="getDescription(e)"
        matTooltipPosition="right"
        class="ms-2 text-secondary icon-compact mt-1"
        >info</mat-icon
      >
    </span>
    <p
      *ngIf="e.showDescription === 1"
      class="text-muted mb-0"
      style="font-size: 0.875rem"
    >
      {{ getDescription(e) }}
    </p>
  </label>
</ng-template>

<!-- Date Field Template -->
<ng-template
  #dateField
  let-e="e"
  let-field="field"
  let-type="type"
  let-icon="icon"
>
  <div *ngIf="e['type'] == type" class="mb-2">
    <div *ngIf="evaluateCondition(field)">
      <mat-form-field
        appearance="outline"
        class="w-100"
        subscriptSizing="dynamic"
      >
        <input
          #dateInput
          matInput
          [type]="getInputType(e.type)"
          [(ngModel)]="entryform.data[e.code]"
          id="{{ e.code }}"
          name="{{ e.code }}"
          [required]="e['required'] == 1"
          [readonly]="
            e['readOnly'] ||
            (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
          "
          (change)="
            checkRuleExecute(e.code);
            onDateChange($event, e.code, getInputType(e.type));
            enforceMaxDate($event, e.code, e.type)
          "
          (input)="restrictDecimalPlaces($event, e, e?.placeValue)"
          [min]="e.type === 'date' ? e.minDate : null"
          [max]="e.type === 'date' ? e.maxDate : null"
        />
        <button
          mat-icon-button
          matSuffix
          class="icon-pd-none"
          type="button"
          (click)="dateInput.showPicker()"
        >
          <mat-icon class="icon-compact text-secondary">{{ icon }}</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
</ng-template>

<!-- Time Field Template -->
<ng-template
  #timeField
  let-e="e"
  let-field="field"
  let-type="type"
  let-icon="icon"
>
  <div *ngIf="e['type'] == type" class="mb-2">
    <div *ngIf="evaluateCondition(field)">
      <mat-form-field
        appearance="outline"
        class="w-100"
        subscriptSizing="dynamic"
      >
        <input
          #timeInput
          matInput
          type="time"
          [(ngModel)]="entryform.data[e.code]"
          id="{{ e.code }}"
          name="{{ e.code }}"
          [required]="e['required'] == 1"
          [readonly]="
            e['readOnly'] ||
            (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
          "
          (change)="
            checkRuleExecute(e.code);
            onDateChange($event, e.code, getInputType(e.type));
            enforceMaxDate($event, e.code, e.type)
          "
          (input)="restrictDecimalPlaces($event, e, e?.placeValue)"
        />
        <button
          mat-icon-button
          matSuffix
          class="icon-pd-none"
          type="button"
          (click)="timeInput.showPicker()"
        >
          <mat-icon class="icon-compact text-secondary">{{ icon }}</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
</ng-template>

<!-- IDate Field Template -->
<ng-template #idateField let-e="e" let-field="field">
  <div *ngIf="e['type'] == 'idate'" class="mb-2">
    <div *ngIf="evaluateCondition(field)">
      <mat-form-field
        appearance="outline"
        class="w-100"
        subscriptSizing="dynamic"
      >
        <input
          #dateInput
          matInput
          type="date"
          [(ngModel)]="entryform.data[e.code]"
          id="{{ e.code }}"
          name="{{ e.code }}"
          [required]="e['required'] == 1"
          [readonly]="
            e['readOnly'] ||
            (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
          "
          (change)="
            checkRuleExecute(e.code);
            onDateChange($event, e.code, getInputType(e.type));
            enforceMaxDate($event, e.code, e.type)
          "
          (input)="restrictDecimalPlaces($event, e, e?.placeValue)"
          [min]="e.type === 'idate' ? convertIntoLocalDate(e.minDate) : null"
          [max]="e.type === 'idate' ? convertIntoLocalDate(e.maxDate) : null"
        />
        <button
          mat-icon-button
          matSuffix
          class="icon-pd-none"
          type="button"
          (click)="dateInput.showPicker()"
        >
          <mat-icon class="icon-compact text-secondary"
            >calendar_today</mat-icon
          >
        </button>
      </mat-form-field>
    </div>
  </div>
</ng-template>

<!-- DateTime Field Template -->
<ng-template #datetimeField let-e="e" let-field="field">
  <div *ngIf="e['type'] === 'dateandtime'" class="mb-2">
    <div *ngIf="evaluateCondition(field)">
      <mat-form-field
        appearance="outline"
        class="w-100"
        subscriptSizing="dynamic"
      >
        <input
          #dateTimeInput
          matInput
          type="datetime-local"
          [(ngModel)]="entryform.data[e.code]"
          id="{{ e.code }}"
          name="{{ e.code }}"
          [required]="e.required"
          [readonly]="
            e['readOnly'] ||
            (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
          "
        />
        <button
          mat-icon-button
          matSuffix
          class="icon-pd-none"
          type="button"
          (click)="dateTimeInput.showPicker()"
        >
          <mat-icon class="icon-compact text-secondary"
            >calendar_month</mat-icon
          >
        </button>
      </mat-form-field>
    </div>
  </div>
</ng-template>

<!-- Location Field Template -->
<ng-template #locationField let-e="e">
  <div
    *ngIf="e['type'] === 'location'"
    class="mb-3 d-flex align-items-center flex-wrap"
  >
    <div class="d-flex align-items-center flex-wrap">
      <ng-container
        *ngIf="
          entryform.data[e.code]?.lat != null &&
            entryform.data[e.code]?.lng != null;
          else noLocation
        "
        class="d-flex align-items-center flex-wrap"
      >
        <mat-form-field
          appearance="outline"
          class="me-2 mb-3"
          subscriptSizing="dynamic"
        >
          <mat-label>Latitude</mat-label>
          <input
            matInput
            type="number"
            readonly
            [(ngModel)]="entryform.data[e.code].lat"
            [name]="e.code + '_lat'"
          />
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="me-2 mb-3"
          subscriptSizing="dynamic"
        >
          <mat-label>Longitude</mat-label>
          <input
            matInput
            type="number"
            readonly
            [(ngModel)]="entryform.data[e.code].lng"
            [name]="e.code + '_lng'"
          />
        </mat-form-field>
      </ng-container>
      <ng-template #noLocation>
        <mat-form-field
          appearance="outline"
          class="me-2 mb-3"
          subscriptSizing="dynamic"
        >
          <mat-label>Latitude</mat-label>
          <input
            matInput
            readonly
            value="No location set"
            [name]="e.code + '_lat_placeholder'"
          />
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="me-2 mb-3"
          subscriptSizing="dynamic"
        >
          <mat-label>Longitude</mat-label>
          <input
            matInput
            readonly
            value="No location set"
            [name]="e.code + '_lng_placeholder'"
          />
        </mat-form-field>
      </ng-template>

      <button
        mat-stroked-button
        type="button"
        color="warn"
        class="icon-width me-1 mb-3"
        title="Set current location"
        (click)="setCurrentLocation(e.code)"
      >
        <mat-icon class="icon-compact">location_on</mat-icon>
      </button>
      <button
        mat-stroked-button
        type="button"
        color="primary"
        class="icon-width me-1 mb-3"
        title="View on map"
        (click)="viewOnMap(e.code)"
      >
        <mat-icon class="icon-compact">map</mat-icon>
      </button>
      <button
        mat-stroked-button
        type="button"
        color="warn"
        class="icon-width mb-3"
        title="Clear location"
        (click)="clearLocation(e.code)"
      >
        <i class="fa fa-eraser icon-compact"></i>
      </button>
    </div>
  </div>
</ng-template>

<!-- Boolean Field Template -->
<ng-template #booleanField let-e="e">
  <div *ngIf="e['type'] === 'boolean'" class="mb-2">
    <mat-form-field
      appearance="outline"
      class="w-100"
      subscriptSizing="dynamic"
    >
      <mat-select
        [ngModel]="
          entryform.data[e.code] === undefined ? '' : entryform.data[e.code]
        "
        (ngModelChange)="
          entryform.data[e.code] = $event === '' ? undefined : $event
        "
        id="{{ e.code }}"
        name="{{ e.code }}"
      >
        <mat-option value="" style="display: none"
          >-- Select -- {{ e.label }}</mat-option
        >
        <mat-option [value]="1">{{
          "Uiformedit.BOOLEAN.TRUE" | translate
        }}</mat-option>
        <mat-option [value]="0">{{
          "Uiformedit.BOOLEAN.FALSE" | translate
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>

<!-- Password Field Template -->
<ng-template #passwordField let-e="e">
  <div *ngIf="e['type'] === 'password'" class="mb-2">
    <mat-form-field
      appearance="outline"
      class="w-100"
      subscriptSizing="dynamic"
    >
      <input
        matInput
        [id]="e.code"
        [name]="e.code"
        [type]="showPassword ? 'text' : 'password'"
        [(ngModel)]="entryform.data[e.code]"
        [placeholder]="getFilterLable(e.label) || 'Enter password'"
      />
      <button
        matSuffix
        mat-icon-button
        type="button"
        class="icon-pd-none"
        (click)="togglePasswordVisibility()"
        [attr.aria-label]="'Toggle password visibility'"
        [attr.aria-pressed]="showPassword"
      >
        <mat-icon class="icon-compact text-secondary">{{
          showPassword ? "visibility" : "visibility_off"
        }}</mat-icon>
      </button>
    </mat-form-field>
  </div>
</ng-template>

<!-- JSON Field Template -->
<ng-template #jsonField let-e="e" let-field="field">
  <div *ngIf="e['type'] === 'json'" class="mb-2">
    <div *ngIf="evaluateCondition(field)">
      <mat-form-field
        appearance="outline"
        class="w-100 textarea-container"
        subscriptSizing="dynamic"
      >
        <textarea
          matInput
          [(ngModel)]="entryform.data[e.code]"
          id="jsonDefault"
          name="jsonDefault"
          rows="2"
          class="font-monospace"
          placeholder='{ "key": "value" }'
        ></textarea>
      </mat-form-field>
    </div>
  </div>
</ng-template>

<!-- Reference Key Field Template -->
<ng-template #refKeyField let-e="e" let-field="field">
  <div *ngIf="e['refKey'] == 1" class="mb-2">
    <div *ngIf="evaluateCondition(field)" class="d-flex align-items-center">
      <mat-form-field appearance="outline" class="w-100">
        <mat-select
          [(ngModel)]="entryform.data[e.code]"
          [disabled]="
            e['readOnly'] ||
            (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
          "
          [compareWith]="compareFn"
          [required]="e['required'] == 1"
          [id]="e.code"
          [name]="e.code"
          [placeholder]="getFilterLable(e.label)"
          [ngClass]="{
            'placeholder-grey':
              entryform.data[e.code] === undefined ||
              entryform.data[e.code] === 'undefined' ||
              entryform.data[e.code] === '' ||
              entryform.data[e.code] === null,
          }"
          (selectionChange)="
            onChange(e, { id: $event.value });
            checkRuleExecute(e.code);
            resetChildren(e.code)
          "
        >
          <mat-option>
            <ngx-mat-select-search
              [placeholderLabel]="'Search ' + e.label + '...'"
              noEntriesFoundLabel="No results found"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="e['_searchTerm']"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option [value]="null">-- None --</mat-option>
          <ng-container
            *ngFor="
              let item of getFilteredData(
                form.preload?.[e.primaryUsecase] || []
              )
            "
          >
            <mat-option
              *ngIf="
                !e['_searchTerm'] ||
                item['_val']
                  ?.toString()
                  .toLowerCase()
                  .includes(e['_searchTerm'].toLowerCase())
              "
              [value]="item.id"
            >
              {{ item._val }}
            </mat-option>
          </ng-container>
        </mat-select>
        <mat-error *ngIf="e['required'] == 1"
          >{{ e.label }} is required</mat-error
        >
      </mat-form-field>
    </div>
  </div>
</ng-template>

<!-- List Field Template -->
<ng-template #listField let-e="e" let-field="field">
  <div *ngIf="e['type'] === 'list'" class="mb-2 w-100">
    <!-- Dropdown / Checkbox style -->
    <div
      *ngIf="
        e['listType'] === 'none' ||
        e['listType'] === '' ||
        !e['listType'] ||
        e['listType'] === 'checkbox'
      "
      class="d-flex align-items-center w-100"
    >
      <div *ngIf="e['multipleSelect'] == 1" class="position-relative w-100">
        <mat-form-field
          appearance="outline"
          class="w-100"
          subscriptSizing="dynamic"
        >
          <mat-select
            [multiple]="true"
            [(ngModel)]="entryform.data[e.code]"
            [disabled]="
              e['readOnly'] ||
              (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
            "
            (selectionChange)="onCheckboxChange(e, $event.value, $event)"
            [required]="e['required'] == 1"
            [id]="e.code"
            [name]="e.code"
            [placeholder]="'--Select-- ' + e.label"
            (openedChange)="toggleDropdown(e)"
          >
            <mat-select-trigger>
              <span
                class="text-truncate"
                [ngClass]="{ 'placeholder-grey': !getSelectedText(e) }"
              >
                {{ getSelectedText(e) || "" }}
              </span>
            </mat-select-trigger>

            <ngx-mat-select-search
              #searchMulti
              [placeholderLabel]="'Search...'"
              [noEntriesFoundLabel]="'No matches'"
            ></ngx-mat-select-search>

            <mat-option
              *ngFor="let option of e['values']"
              [value]="option"
              class="p-1"
              [style.display]="
                !searchMulti.value ||
                option.toLowerCase().includes(searchMulti.value.toLowerCase())
                  ? 'flex !important'
                  : 'none !important'
              "
            >
              <span [title]="option">
                {{ option | truncate: getTruncateLimit(form.data.columns) }}
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-form-field
        *ngIf="e['multipleSelect'] != 1"
        appearance="outline"
        class="w-100"
        subscriptSizing="dynamic"
      >
        <mat-select
          [ngModel]="
            entryform.data[e.code] === undefined ? '' : entryform.data[e.code]
          "
          (ngModelChange)="
            entryform.data[e.code] = $event === '' ? undefined : $event
          "
          [disabled]="
            e['readOnly'] ||
            (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
          "
          [required]="e['required'] == 1"
          [id]="e.code"
          [name]="e.code"
          [placeholder]="'--Select-- ' + e.label"
          (selectionChange)="onChange(e, $event)"
          (openedChange)="toggleDropdown(e)"
          [ngClass]="{
            'placeholder-grey':
              entryform.data[e.code] === undefined ||
              entryform.data[e.code] === 'undefined',
          }"
        >
          <ngx-mat-select-search
            #searchSingle
            [placeholderLabel]="'Search...'"
            [noEntriesFoundLabel]="'No matches'"
          ></ngx-mat-select-search>

          <mat-option
            value=""
            [disabled]="e['required'] == 1"
            [style.display]="
              !searchSingle.value ? 'flex !important' : 'none !important'
            "
          >
            --Select-- {{ e.label }}
          </mat-option>

          <mat-option
            *ngFor="let c of e['values']"
            [value]="c"
            [title]="c"
            [style.display]="
              !searchSingle.value ||
              (c &&
                c
                  .toString()
                  .toLowerCase()
                  .includes(searchSingle.value.toLowerCase()))
                ? 'flex !important'
                : 'none !important'
            "
          >
            {{ c | truncate: getTruncateLimit(form.data.columns) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Radio -->
    <div *ngIf="e['listType'] === 'radio'" class="w-100">
      <mat-radio-group
        *ngIf="e['showVertical'] === 'horizontal'"
        [(ngModel)]="entryform.data[e.code]"
        [name]="e.code"
        class="d-flex flex-row flex-wrap"
      >
        <mat-radio-button
          *ngFor="let option of e['values']"
          [value]="option"
          color="primary"
          [disabled]="
            e['readOnly'] ||
            (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
          "
          class="me-3"
          (change)="onRadioChange(e, option)"
          >{{ option }}</mat-radio-button
        >
      </mat-radio-group>

      <mat-radio-group
        *ngIf="e['showVertical'] === 'vertical'"
        [(ngModel)]="entryform.data[e.code]"
        [name]="e.code"
        class="d-flex flex-column"
      >
        <mat-radio-button
          *ngFor="let option of e['values']"
          [value]="option"
          color="primary"
          [disabled]="
            e['readOnly'] ||
            (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
          "
          (change)="onRadioChange(e, option)"
          >{{ option }}</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>
</ng-template>

<!-- File Field Template -->
<ng-template #fileField let-e="e">
  <div *ngIf="e['type'] === 'file'" class="mb-2">
    <div class="d-flex align-items-center">
      <mat-form-field appearance="outline" class="w-100">
        <input
          matInput
          readonly
          placeholder="Choose file here.."
          [value]="file.files?.[0]?.name || ''"
          (click)="file.click()"
          style="cursor: pointer"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          class="icon-pd-none"
          (click)="file.click()"
        >
          <mat-icon class="icon-compact">attach_file</mat-icon>
        </button>
        <input
          type="file"
          #file
          hidden
          id="entryform.data[e.code]"
          name="entryform.data[e.code]"
          accept="image/*"
          [disabled]="e.captureImage == 1"
          (click)="onFileChooseClicked(file, e.code)"
          (change)="file.files && openCropperModal($event, e.code)"
        />
      </mat-form-field>
    </div>
    <div *ngIf="fileErrors[e.code]" class="text-danger">
      {{ "Uiformedit.ERRORS.INVALID_FILE_TYPE" | translate }}
    </div>
    <div *ngIf="imageSizes[e.code]" class="text-danger">
      {{
        "Uiformedit.ERRORS.FILE_SIZE_LIMIT" | translate: { size: e.size || 1 }
      }}
    </div>
  </div>
  <div class="mb-4" *ngIf="e['type'] === 'file'">
    <div *ngIf="!fileErrors[e.code] && !imageSizes[e.code]">
      <a [href]="getAppDoc(entryform.data[e.code])" target="_blank">
        <img
          [src]="
            imagePreviews[e.code]
              ? imagePreviews[e.code]
              : getAppDocThumbnail(entryform.data[e.code])
          "
          alt="Image Preview"
          class="img-thumbnail"
          style="width: 200px"
        />
      </a>
    </div>
  </div>
</ng-template>

<!-- Doc Field Template -->
<ng-template #docField let-e="e">
  <div *ngIf="e['type'] === 'doc'" class="mb-2">
    <div class="d-flex align-items-center">
      <mat-form-field appearance="outline" class="w-100">
        <input
          matInput
          readonly
          placeholder="Choose file here.."
          [value]="filedoc.files?.[0]?.name || ''"
          (click)="filedoc.click()"
          style="cursor: pointer"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          class="icon-pd-none"
          (click)="filedoc.click()"
        >
          <mat-icon class="icon-compact">attach_file</mat-icon>
        </button>
        <input
          type="file"
          #filedoc
          hidden
          id="entryform.data[e.code]"
          name="entryform.data[e.code]"
          (change)="
            filedoc.files && onFileChanged($event, e, entryform.data[e.code])
          "
        />
      </mat-form-field>
    </div>
    <div *ngIf="docSizes[e.code]" class="text-danger">
      {{
        "Uiformedit.ERRORS.FILE_SIZE_LIMIT" | translate: { size: e.size || 1 }
      }}
    </div>
    <div *ngIf="docFileErrors[e.code]" class="text-danger">
      {{ "Uiformedit.ERRORS.INVALID_DOC_TYPE" | translate }}
    </div>
  </div>
  <div class="mb-4" *ngIf="e['type'] === 'doc'">
    <a href="{{ getAppDoc(entryform.data[e.code]) }}" target="_blank">
      <img
        [src]="
          imagePreview == null
            ? getAppDocThumbnail(entryform.data[e.code])
            : imagePreview
        "
        alt="Image Preview"
        class="img-thumbnail"
        style="width: 200px; height: 150px"
      />
    </a>
  </div>
</ng-template>

<!-- Map Field Template -->
<ng-template #mapField let-e="e">
  <div *ngIf="e['type'] === 'map'" class="mb-2">
    <div class="d-flex align-items-center w-100">
      <mat-form-field
        appearance="outline"
        class="w-100"
        subscriptSizing="dynamic"
      >
        <mat-select
          [ngModel]="
            entryform.data[e.code] === undefined ? '' : entryform.data[e.code]
          "
          (ngModelChange)="
            entryform.data[e.code] = $event === '' ? undefined : $event
          "
          [required]="e['required'] == 1"
          [disabled]="
            e['readOnly'] ||
            (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
          "
          [placeholder]="'--Select-- ' + e.code"
          [ngClass]="{
            'placeholder-grey':
              entryform.data[e.code] === undefined ||
              entryform.data[e.code] === 'undefined',
          }"
          (selectionChange)="onChange(e, $event)"
          id="{{ e.code }}"
          name="{{ e.code }}"
        >
          <mat-option value="" style="display: none"
            >--Select-- {{ e.code }}</mat-option
          >
          <mat-option
            *ngFor="let c of e['values']"
            value="{{ c.key }} - {{ c.value }}"
          >
            {{ c.key }} - {{ c.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</ng-template>

<!-- ================================================================ -->
<!-- MODALS                                                            -->
<!-- ================================================================ -->

<!-- Share Email Modal -->
<div
  class="modal fade compact-inputs dropdown-pd-none"
  id="shareModalLabel"
  tabindex="-1"
  aria-labelledby="shareModalLabelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="shareModalLabelLabel">
          {{ "Uiformedit.SHARE.TITLE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p *ngIf="sform['error'] == false && sform['message']">
          <app-ncs-alert [message]="sform['message']" type="success" />
        </p>
        <p *ngIf="sform['error'] == true && sform['message']">
          <app-ncs-alert [message]="sform['message']" type="danger" />
        </p>
        <form #uform="ngForm">
          <div class="mb-3">
            <label for="name" class="form-label">{{
              "Uiformedit.SHARE.NAME" | translate
            }}</label>
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                [(ngModel)]="sform.data['name']"
                type="text"
                id="name"
                name="name"
                [placeholder]="'Uiformedit.SHARE.NAME_PLACEHOLDER' | translate"
                required
              />
            </mat-form-field>
          </div>
          <div class="mb-3">
            <label for="email" class="form-label">{{
              "Uiformedit.SHARE.EMAIL" | translate
            }}</label>
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                [(ngModel)]="sform.data['email']"
                (change)="checkEmail(sform.data['email'])"
                type="email"
                id="email"
                name="email"
                [placeholder]="'Uiformedit.SHARE.EMAIL_PLACEHOLDER' | translate"
                required
              />
            </mat-form-field>
            <span style="color: red" *ngIf="datavalidate">{{
              "Uiformedit.ERRORS.INVALID_EMAIL" | translate
            }}</span>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          [disabled]="btnDisable || !uform.valid"
          (click)="sharePdf()"
        >
          <mat-icon>share</mat-icon>
          <span>{{ "Uiformedit.SHARE.SHARE" | translate }}</span>
        </button>
        <button mat-stroked-button color="warn" data-bs-dismiss="modal">
          <mat-icon>close</mat-icon>
          <span>{{ "Uiformedit.BUTTONS.CLOSE" | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Comment Modal -->
<div
  class="modal fade"
  id="commentModel"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="commentModelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mb-0" id="commentModelLabel">
          {{ "UIFORM.COMMENTS.COMMENTES" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="resetcommentForm()"
        ></button>
      </div>
      <div class="modal-body">
        <p *ngIf="commentform['error'] == false && commentform['message']">
          <app-ncs-alert [message]="commentform['message']" type="success" />
        </p>
        <p *ngIf="commentform['error'] == true && commentform['message']">
          <app-ncs-alert [message]="commentform['message']" type="danger" />
        </p>
        <mat-form-field appearance="outline" class="w-100 textarea-container">
          <mat-label>{{ "UIFORM.COMMENTS.COMMENT" | translate }}</mat-label>
          <textarea
            matInput
            [(ngModel)]="commentform.data['comment']"
            name="comment"
            id="comment"
            required
            rows="3"
          ></textarea>
        </mat-form-field>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          [disabled]="isSaving || isSaved || !commentform.data['comment']"
          (click)="addPageComment()"
        >
          <mat-icon>save</mat-icon> {{ "UIFORM.BUTTON.SAVE" | translate }}
        </button>
        <button
          mat-stroked-button
          color="warn"
          (click)="resetcommentForm()"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "UIFORM.COMMENTS.FORM.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Attachment Modal -->
<div
  class="modal fade compact-inputs dropdown-pd-none"
  id="attachmentModel"
  tabindex="-1"
  aria-labelledby="attachmentModelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="attachmentModelLabel">
          {{ "UIFORM.ATTACHMENTS.ATTACHMENTES" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="resetattachmentForm()"
        ></button>
      </div>
      <div class="modal-body">
        <p
          *ngIf="attachmentform['error'] == false && attachmentform['message']"
        >
          <app-ncs-alert [message]="attachmentform['message']" type="success" />
        </p>
        <p *ngIf="attachmentform['error'] == true && attachmentform['message']">
          <app-ncs-alert [message]="attachmentform['message']" type="danger" />
        </p>
        <div class="mb-2">
          <label for="description" class="form-label">{{
            "UIFORM.ATTACHMENTS.DESCRIPTION" | translate
          }}</label>
          <mat-form-field appearance="outline" class="w-100 textarea-container">
            <textarea
              matInput
              [(ngModel)]="attachmentform.data['description']"
              name="description"
              id="description"
              rows="3"
            ></textarea>
          </mat-form-field>
        </div>

        <div class="my-2">
          <label for="attachment" class="form-label">
            {{ "UIFORM.ATTACHMENTS.ATTACHMENT" | translate }}
            <span class="text-danger">*</span>
          </label>
          <mat-form-field appearance="outline" class="w-100">
            <input
              (click)="fileAttechment.click()"
              matInput
              readonly
              placeholder="{{
                'UIFORM.ATTACHMENTS.FORM.ATTACHMENT_PLACE' | translate
              }}"
              [value]="fileAttechment?.files?.[0]?.name || ''"
              style="cursor: pointer"
              required
            />
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="fileAttechment.click()"
              class="icon-pd-none"
            >
              <mat-icon class="compact-icon text-secondary"
                >attach_file</mat-icon
              >
            </button>
          </mat-form-field>
          <input
            #fileAttechment
            type="file"
            hidden
            id="attachment"
            name="attachment"
            required
            [(ngModel)]="attachmentform.data['attachment']"
            (change)="fileAttechment.files && onAttachmentformChanged($event)"
          />
        </div>

        <div class="my-2">
          <label class="form-label">{{
            "UIFORM.ATTACHMENTS.PREVIEW" | translate
          }}</label>
          <div>
            <img
              [src]="
                imageAttachmentPreview == null
                  ? getAppDocThumbnail(attachmentform.data['attachment'])
                  : imageAttachmentPreview
              "
              [alt]="'UsecaseData.MODAL.ATTACHMENT.PREVIEW_ALT' | translate"
              class="img-thumbnail"
              style="max-width: 200px"
            />
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          [disabled]="
            isSaving ||
            (attachmentform.data['attachment'] == null &&
              imageAttachmentPreview == null)
          "
          (click)="saveAttachment()"
        >
          <mat-icon>save</mat-icon> {{ "UIFORM.BUTTON.SAVE" | translate }}
        </button>
        <button
          mat-stroked-button
          color="warn"
          (click)="resetattachmentForm()"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "UIFORM.ATTACHMENTS.FORM.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Attachment Info Modal -->
<div class="modal fade" id="appAttachmentInfo" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">
          <i class="bi bi-info-circle me-2"></i
          >{{ "Uiformedit.ATTACHMENTS.INFO_TITLE" | translate }}
        </h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>{{ "Uiformedit.TABLE.KEY" | translate }}</th>
              <th>{{ "Uiformedit.TABLE.VALUE" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Organization</td>
              <td>{{ appAttachmentInfo?.["orgName"] }}</td>
            </tr>
            <tr>
              <td>Version</td>
              <td>{{ appAttachmentInfo?.version }}</td>
            </tr>
            <tr>
              <td>Created By</td>
              <td>{{ appAttachmentInfo?.createdBy }}</td>
            </tr>
            <tr>
              <td>Created Date</td>
              <td>
                {{
                  appAttachmentInfo?.createdDatetime
                    | date: "MMM d, y, h:mm:ss a"
                }}
              </td>
            </tr>
            <tr>
              <td>Modified By</td>
              <td>{{ appAttachmentInfo?.modifiedBy }}</td>
            </tr>
            <tr>
              <td>Modified Date</td>
              <td>
                {{
                  appAttachmentInfo?.modifiedDatetime
                    | date: "MMM d, y, h:mm:ss a"
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button mat-stroked-button color="warn" data-bs-dismiss="modal">
          <mat-icon>close</mat-icon> Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Comment Info Modal -->
<div class="modal fade" id="appCommentInfo" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title mb-0">
          <i class="bi bi-info-circle me-2"></i
          >{{ "COMMENTS.INFO_TITLE" | translate }}
        </h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>{{ "Uiformedit.TABLE.KEY" | translate }}</th>
              <th>{{ "Uiformedit.TABLE.VALUE" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Organization</td>
              <td>{{ appCommentInfo?.["orgName"] }}</td>
            </tr>
            <tr>
              <td>Version</td>
              <td>{{ appCommentInfo?.version }}</td>
            </tr>
            <tr>
              <td>Created By</td>
              <td>{{ appCommentInfo?.createdBy }}</td>
            </tr>
            <tr>
              <td>Created Date</td>
              <td>
                {{
                  appCommentInfo?.createdDatetime | date: "MMM d, y, h:mm:ss a"
                }}
              </td>
            </tr>
            <tr>
              <td>Modified By</td>
              <td>{{ appCommentInfo?.modifiedBy }}</td>
            </tr>
            <tr>
              <td>Modified Date</td>
              <td>
                {{
                  appCommentInfo?.modifiedDatetime | date: "MMM d, y, h:mm:ss a"
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button mat-stroked-button color="warn" data-bs-dismiss="modal">
          <mat-icon>close</mat-icon> Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Image Cropper Modal -->
<div class="modal fade" id="imageModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Crop Image</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="cancelCrop()"
        ></button>
      </div>

      <div class="button-row" *ngIf="showCropper">
        <button
          mat-stroked-button
          color="primary"
          [class.enabled]="transform.flipV"
          (click)="zoomIn()"
          [matTooltip]="'PROFILE.IMAGE_MODAL.ZOOM_IN' | translate"
        >
          <mat-icon>add_photo_alternate</mat-icon>
          {{ "PROFILE.IMAGE_MODAL.ZOOM_IN" | translate }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          [class.enabled]="transform.flipV"
          (click)="zoomOut()"
          [matTooltip]="'PROFILE.IMAGE_MODAL.ZOOM_OUT' | translate"
        >
          <mat-icon>remove_photo_alternate</mat-icon>
          {{ "PROFILE.IMAGE_MODAL.ZOOM_OUT" | translate }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          [class.enabled]="transform.flipV"
          (click)="rotateRight()"
          [matTooltip]="'PROFILE.IMAGE_MODAL.ROTATE_RIGHT' | translate"
        >
          <mat-icon>rotate_right</mat-icon>
          {{ "PROFILE.IMAGE_MODAL.ROTATE_RIGHT" | translate }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          [class.enabled]="transform.flipV"
          (click)="rotateLeft()"
          [matTooltip]="'PROFILE.IMAGE_MODAL.ROTATE_LEFT' | translate"
        >
          <mat-icon>rotate_left</mat-icon>
          {{ "PROFILE.IMAGE_MODAL.ROTATE_LEFT" | translate }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          [class.enabled]="transform.flipH"
          (click)="flipHorizontal()"
          [matTooltip]="'PROFILE.IMAGE_MODAL.FLIP_HORIZONTAL' | translate"
        >
          <mat-icon>flip</mat-icon>
          {{ "PROFILE.IMAGE_MODAL.FLIP_HORIZONTAL" | translate }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          [class.enabled]="transform.flipV"
          (click)="flipVertical()"
          [matTooltip]="'PROFILE.IMAGE_MODAL.FLIP_VERTICAL' | translate"
        >
          <mat-icon>flip</mat-icon>
          {{ "PROFILE.IMAGE_MODAL.FLIP_VERTICAL" | translate }}
        </button>
      </div>

      <div class="modal-body">
        <div class="w-100">
          <div class="cropper-wrapper">
            <image-cropper
              [disabled]="disabled"
              [alignImage]="alignImage"
              [roundCropper]="roundCropper"
              [hidden]="hidden"
              [imageChangedEvent]="imageChangedEvent"
              [hideResizeSquares]="hideResizeSquares"
              [maintainAspectRatio]="false"
              [canvasRotation]="canvasRotation"
              [containWithinAspectRatio]="false"
              [(transform)]="transform"
              [aspectRatio]="aspectRatio"
              format="png"
              [cropperStaticWidth]="cropperStaticWidth"
              [cropperStaticHeight]="cropperStaticHeight"
              [cropperMinWidth]="cropperMinWidth"
              [cropperMinHeight]="cropperMinHeight"
              [cropperMaxWidth]="cropperMaxWidth"
              [cropperMaxHeight]="cropperMaxHeight"
              [resetCropOnAspectRatioChange]="resetCropOnAspectRatioChange"
              [onlyScaleDown]="true"
              [style.width.%]="100"
              [style.height.%]="100"
              (imageCropped)="imageCropped($event)"
              (imageLoaded)="imageLoaded()"
              (cropperReady)="cropperReady($event)"
              (loadImageFailed)="loadImageFailed()"
            ></image-cropper>
          </div>
        </div>

        <div class="preview-card">
          <h6 class="fw-bold">Preview</h6>
          <div class="text-center">
            <img
              *ngIf="croppedImage"
              [src]="croppedImage"
              alt="Cropped Preview"
              class="img-thumbnail"
            />
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          [disabled]="!croppedImage"
          (click)="saveCroppedImage()"
          data-bs-dismiss="modal"
        >
          <mat-icon class="me-1">save</mat-icon> {{ "COMMON.SAVE" | translate }}
        </button>
        <button
          mat-stroked-button
          (click)="cancelCrop()"
          data-bs-dismiss="modal"
          color="warn"
        >
          <mat-icon class="me-1">close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
